<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-py-md' : 'q-py-lg']">
    <div :class="['column col-11', isMobile ? undefined : 'q-px-sm']">

      <!-- title, image -->
      <div class="row full-width border-radius border-solid bg-white q-mb-md items-stretch text-grey-4">

        <!-- image -->
        <div v-if="!isMobile" class="col-3 q-mr-xl">
          <q-img class="border-radius" src="img/privacy.jpg" width="100%"/>
        </div>

        <!-- title -->
        <div :class="['column col-12 col-md-auto justify-center', isMobile ? 'q-pa-sm' : undefined]">

          <!-- english title -->
          <div v-if="!isMobile" class="border-radius bg-primary q-mb-lg q-px-md q-py-xs" style="width: fit-content">
            <div class="text-h6 text-weight-regular text-white" style="font-family: Bahnschrift">
              Terms & Conditions
            </div>
          </div>

          <!-- persian title -->
          <div>

            <!-- mobile -->
            <div v-if="isMobile"
                 class="text-subtitle1 text-bold text-center text-grey-9">
              قوانین و مقررات
            </div>

            <!-- desktop -->
            <h1 v-else class="no-margin text-weight-regular text-grey-9">
              قوانین و مقررات
            </h1>

          </div>

        </div>

      </div>

      <!-- content -->
      <div class="row full-width border-radius border-solid bg-white q-pa-md text-grey-4">

        <!-- terms -->
        <div class="ck-content full-width border-radius bg-white text-black" style="line-height: 28px" v-html="terms"/>

        <div class="column q-gutter-y-md text-black">

          <div class="text-subtitle1 text-bold">
            مرام‌نامه حامیانه
          </div>

          <ul>

            <li class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
              از انتشار تصاویر ناراحت کننده و خشونت آمیز معذوریم
            </li>

            <li class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
              از انتشار تصاویر و فیلم های حاوی تصاویر چهره و یا فیلم هایی که در آن مشخصات مددجویان ذکر می شود معذوریم
            </li>

            <li class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
              از انتشار کلمات و جملات حاوی الفاظ رکیک و همچنین خشونت آمیز و به دور از شان معذرویم
            </li>

            <li class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
              جهت ایجاد یک تجربه شخصی و منحصر به فرد در وبسایت و نرم‌افزارهای این مجموعه این اطلاعات جمع‌آوری و تحلیل
              می‌شوند.
            </li>

          </ul>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";

export default {
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    if (store.state.preFetch.terms == null)
      await store.dispatch('loadApplicationTerms')
    await store.dispatch('getMeta', {pageUrl: 'https://www.hamiane.com/terms'})
    let meta = {}
    meta.title = store.state.preFetch.pageMeta.metaTitle
    meta.description = store.state.preFetch.pageMeta.metaDescription
    meta.keywords = store.state.preFetch.pageMeta.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  name: "Terms",
  computed: {
    terms() {
      return this.$store.state.preFetch.terms
    },
    isMobile() {
      return this.$q.screen.lt.md
    }
  },
  mounted() {
    useMeta(this.$store.state.meta)
    this.$store.commit('setPageLoadState', true)
  }
}
</script>

<style scoped>
h1 {
  font-size: 22px !important;
  line-height: 28px;
}
</style>
